import React from "react"
import ColumnTitle from "components/UI/ColumnTitle"
import List from "components/UI/List"
import { CardWrapper } from "components/UI/Card"
import InternalLink from "components/UI/InternalLink"
import ContentDecoration from "components/UI/ContentDecoration"
import linkResolver from "utils/linkResolver"
import t from "theme"

const FeaturedArticlesSidebar = ({ title, featureds, homepage = false }) => (
    <div>
        <ColumnTitle>{title}</ColumnTitle>
        <List
            items={featureds.map((featured, index) => (
                <CardWrapper>
                    <InternalLink
                        type={"small"}
                        pathname={linkResolver({ slug: featured.slug, type: "article" })}
                        headline={featured.headline}
                        decoration={
                            <ContentDecoration
                                type={featured.articleType}
                                company={featured.companies ? featured.companies[0] : null}
                                date={featured.sortTimestamp}
                                homepage={homepage}
                                size={t.font.size[2]}
                            />
                        }
                    />
                </CardWrapper>
            ))}
            space={t.space[4]}
            nodivider
        />
    </div>
)

export default FeaturedArticlesSidebar

/*

useStaticQuery does not accept variables (hence the name “static”), but can be used in any component, including pages
Because of how queries currently work in Gatsby, we support only a single instance of useStaticQuery in a file

*/
